import { Link } from 'react-router-dom';

export function NotFound() {
  return (
    <div style={{ padding: 40, textAlign: 'center' }}>
      <h1>404</h1>
      <p style={{ color: '#666', marginTop: 8 }}>Page not found.</p>
      <Link
        to="/"
        style={{
          display: 'inline-block',
          marginTop: 16,
          padding: '8px 20px',
          borderRadius: 8,
          border: '1px solid #ccc',
          textDecoration: 'none',
          color: '#333',
        }}
      >
        Go home
      </Link>
    </div>
  );
}
